<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('orf-to-webp-converter', 'Olympus ORF → WebP');
function handleBatchCreated(batchId: string) { console.log('[ORF to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[ORF to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[ORF to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[ORF to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[ORF to WebP] Credits updated:', credits); }
</script>
